import { Component } from '@angular/core';
import { NavParams, PopoverController, ViewController } from 'ionic-angular';
import 'rxjs';
import { AlertService } from '../../../providers/alert-service';
import { ArquivosService } from '../../../providers/arquivos-service';
import { FileService } from '../../../providers/file-service';
import { GestaoPcaService } from "../../../providers/gestao-pca-service";
import { UsuarioService } from "../../../providers/usuario-service";
import { PopoverAssinantesPage } from "../../popovers/popover-assinantes";
import { PopoverOptions } from "ionic-angular/components/popover/popover-options";
import { AGORA } from "../../../app/AGORA";
import { OpcoesAssinatura } from '../../../assinatura/opcoes-assinatura.model';
import { environment } from '../../../environments/environment';

declare var dtjava: any;

@Component({
  selector: 'page-modal-arquivos',
  templateUrl: 'modal-arquivos.html',
  providers: [
    AGORA
  ]
})
export class ModalArquivosPage {

  isModuloPeca: boolean = false;
  PCAAtiva: any;
  tipoDocumento: any;
  titulo: any;
  isJurisdicionado: any;
  isCGE: any;
  isSefaz: boolean;
  IdProcesso: any = null;
  idModuloPCA: any = null;
  tipoAnalise: any = null;
  tipoEntidadeExercicio: any = null;
  listaTipoDocumentos: any[] = null;
  usuarioLogado: any;
  loading: boolean = true;
  tiposAceitos: any = "application/pdf";
  listaArquivosPCA: any;
  origemArquivo: any;
  origemFilter: any;
  listaPecasProcessuaisObrigatoria: any[];
  origemModal: boolean = false;
  desabilitado: boolean = false;
  buscaArquivo: string = "";
  idProcessoJustificativa: number = null;
  msgErro: string = "";
  msgOk: string = "";
  arquivoOk: string = "";
  arquivoErro: string = "";
  flPegaDocumentoDoModuloDeContrato: boolean;

  analise: any = null;

  opcoes: OpcoesAssinatura;

  constructor(public AGORA: AGORA,
    private alertService: AlertService,
    public popoverCtrl: PopoverController,
    private fileService: FileService,
    private viewCtrl: ViewController,
    public navParams: NavParams,
    public arquivoService: ArquivosService,
    public gestaoPcaService: GestaoPcaService,
    public usuarioService: UsuarioService) {

    this.usuarioLogado = this.usuarioService.obtemUsuario();
    this.PCAAtiva = this.gestaoPcaService.getPCA();
    // console.log("PCAATIVA:");
    // console.log(this.PCAAtiva);

    this.titulo = this.navParams.get('titulo');

    if (this.navParams.get('isModuloPeca') != undefined) {
      this.isModuloPeca = this.navParams.get('isModuloPeca');
    }

    if (this.navParams.get('idProcessoJustificativa') != undefined) {
      this.idProcessoJustificativa = this.navParams.get('idProcessoJustificativa');
    }

    this.isJurisdicionado = this.navParams.get('jurisdicionado');
    this.isCGE = this.navParams.get('isCGE');
    this.isSefaz = this.navParams.get('pFlSefaz');
    // console.log("FlSefaz - Modal: " + this.isSefaz);

    this.IdProcesso = this.navParams.get('IdProcesso');
    this.idModuloPCA = this.navParams.get('idModuloPCA');
    this.tipoAnalise = this.navParams.get('tipoAnalise');
    this.listaTipoDocumentos = this.navParams.get('listaTipoDocumentos');
    this.analise = this.navParams.get('analise');
    this.tipoEntidadeExercicio = this.navParams.get('tipoEntidadeExercicio');
    this.tipoDocumento = this.navParams.get('tipodocumento');

    this.origemFilter = this.navParams.get('origemFilter');

    if (this.navParams.get('flPegaDocumentoDoModuloDeContrato') != undefined && this.navParams.get('flPegaDocumentoDoModuloDeContrato') != null) {
      this.flPegaDocumentoDoModuloDeContrato = this.navParams.get('flPegaDocumentoDoModuloDeContrato');
    } else {
      this.flPegaDocumentoDoModuloDeContrato = false;
    }
    
    if (this.navParams.get('origemArquivo') != undefined && this.navParams.get('origemArquivo') != null) {
      this.origemArquivo = this.navParams.get('origemArquivo');
    } else {
      this.origemArquivo = 'NA';
    }

    if (this.navParams.get('origemFilter') != undefined) {
      this.origemFilter = this.navParams.get('origemFilter');
    } else {
      this.origemFilter = null;
    }

    // if (this.IdProcesso != '' && this.IdProcesso != undefined && this.IdProcesso != 0) {
    //   this.origemModal = true;
    // }

    this.carregarModal();

    this.inicarOpcoesAssinatura();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  carregarModal() {
    this.listarArquivosPCA();
  }

  listarArquivosPCA() {

    if (this.listaTipoDocumentos != null && this.listaTipoDocumentos.length > 0) {

      this.arquivoService.listarArquivosVinculadosPorModuloPcaPorTipoDocumento(this.idModuloPCA, this.listaTipoDocumentos, this.isSefaz).subscribe(data => {
        
        let excecaoParaContratos = data && data[0] && data[0].isContrato; 

        if (!excecaoParaContratos && this.tipoEntidadeExercicio != undefined && this.tipoEntidadeExercicio != 0) {
          if (!this.idProcessoJustificativa) {
            this.listaArquivosPCA = data.filter((arquivo) => arquivo.peca.idTipoEntidadeExercicio == this.tipoEntidadeExercicio);
          } else {
            this.listaArquivosPCA = data.filter((arquivo) => arquivo.peca.idTipoEntidadeExercicio == this.tipoEntidadeExercicio && arquivo.idProcesso != this.idProcessoJustificativa);
          }
        } else {          
          this.listaArquivosPCA = data;
        }
        this.loading = false;
      },  error  => {
        this.loading = false;
        this.msgErro = "Ocorreu um erro ao listar os arquivos: " + error.mensagem;
        this.alertService.mostraAlerta("", this.msgErro); 
      });

    } else {
      this.arquivoService.listarPecasVinculadasPCA(this.IdProcesso, this.idModuloPCA, this.tipoAnalise, this.flPegaDocumentoDoModuloDeContrato).subscribe(data => {
        if (this.tipoEntidadeExercicio != undefined && this.tipoEntidadeExercicio != 0) {
          this.listaArquivosPCA = data.filter((arquivo) => arquivo.peca.idTipoEntidadeExercicio == this.tipoEntidadeExercicio);
        } else {
          this.listaArquivosPCA = data;
        }
        this.loading = false;
      }, error => {
        this.loading = false;
        this.alertService.mostraAlerta("", "Ocorreu um erro ao listar os arquivos:" + error);
      });
    }

    this.arquivoService.listarPecasProcessuaisObrigatoria(this.idModuloPCA).subscribe(data => {
      this.listaPecasProcessuaisObrigatoria = data;

      this.arquivoService.listarPecasProcessuaisNObrigatoria(this.idModuloPCA).subscribe(data2 => {

        if (data2.length > 0) {
          this.listaPecasProcessuaisObrigatoria.push(data2);
        }

        if (this.origemFilter != null) {
          let testFilter = this.listaPecasProcessuaisObrigatoria.filter((tipo) => tipo.nmTipoDocumento == this.origemFilter)[0];

          if (testFilter != undefined) {
            this.tipoDocumento = testFilter;
          }
        }

        if (this.isJurisdicionado && !this.isCGE) {
          if ((<HTMLInputElement>document.getElementById("file"))) {
            if (this.tipoAnalise == '0' || this.tipoDocumento != null || this.tipoDocumento != undefined || this.tipoDocumento != '') {
              if (this.tipoDocumento == 45 && this.isModuloPeca == true) {
                (<HTMLInputElement>document.getElementById("file")).disabled = true;
                // console.log("1");
              } else {
                (<HTMLInputElement>document.getElementById("file")).disabled = false;
                // console.log("2");
              }
            } else {
              if (this.tipoDocumento == 45 && this.isModuloPeca == true) {
                (<HTMLInputElement>document.getElementById("file")).disabled = true;
                // console.log("3");
              } else {
                (<HTMLInputElement>document.getElementById("file")).disabled = false;
                // console.log("4");
              }
            }
          }
        }
      }, error => console.log("erro: " + error));

    }, error => console.log("erro: " + error));
  }

  onTipoDocumentoChange(item) {
    this.tipoEntidadeExercicio = item.idTipoEntidadeExercicio;
    this.tipoDocumento = item.idTipoDocumento;

    if (this.isJurisdicionado && !this.isCGE) {
      this.desabilitado = false;
      (<HTMLInputElement>document.getElementById("file")).disabled = false;
    }
  }

  baixarArquivo(arquivo) {
    this.loading = true;
    this.fileService.baixarArquivo(arquivo);
    this.loading = false;
  }

  mudaArquivo(event) { 
    if (this.validarInclusaoArquivosModuloContabilidade(event.target.files[0])) {
      return;
    }

    let arquivoErro : string = "";
    let arquivoOk: string = "";
    this.alertService.mostraModalConfirmacao("Salvar Peça", "Arquivo selecionado, confirma importação ?", callback => {
      if (callback) {
        console.log("aqui");
        console.log(event);
        let fileList: FileList = event.target.files;
        console.log(fileList);
        if (fileList.length > 0) {
          for (let i = 0; i < fileList.length; i++) {
           let file: File = fileList[i];

            let idTipoDoc = null;


            if (this.tipoDocumento != undefined) {

              if (this.tipoDocumento.idTipoDocumento != undefined) {
                idTipoDoc = this.tipoDocumento.idTipoDocumento;

                /*if (this.tipoDocumento.idTipoDocumento == 335) {
                  if (file.type != 'text/plain') {
                    this.alertService.mostraAlerta('', 'Somente arquivos TXT são aceitos na peça SPED');
                    return;
                  }
                }*/

              } else {
                idTipoDoc = this.tipoDocumento;
                /*if (this.tipoDocumento == 335) {
                  if (file.type != 'text/plain') {
                    this.alertService.mostraAlerta('', 'Somente arquivos TXT são aceitos na peça SPED');
                    return;
                  }
                }*/
              }

            }

            this.fileService.salvarPeca(file, this.IdProcesso, this.idModuloPCA, this.tipoAnalise, this.tipoEntidadeExercicio, idTipoDoc, this.origemArquivo).subscribe(data => {
              this.arquivoOk = this.arquivoOk.concat(file.name,"</br>",'\n'); 
              console.log(this.arquivoOk);
              console.log(file);
              //this.alertService.mostraAlerta("", "Arquivo adicionado com sucesso!");
              this.carregarModal();

              if (this.tipoAnalise != 0 && !this.isCGE) {
                this.desabilitado = true;
                (<HTMLInputElement>document.getElementById("file")).disabled = true;
              }
              if(this.arquivoOk.length > 0 && i === fileList.length - 1 ){
                this.msgOk = "Arquivo(s) adicionado(s) com sucesso:\n" + this.arquivoOk;
                this.alertService.mostraAlerta("", this.msgOk);
                console.log(this.msgOk);
              }

            }, error => {
              this.arquivoErro = this.arquivoErro.concat(file.name,"</br>",'\n');
              if(this.arquivoErro.length > 0 && i === fileList.length - 1){
                this.msgErro ="Ocorreu um erro ao salvar o(s) arquivo: " + error.mensagem;
                this.alertService.mostraAlerta("", this.msgErro);
              }
            });           
            // } else {
            //   this.alertService.mostraAlerta("", "Arquivo ultrapassou o limite de tamanho de 10Mb.");
            // }
          }
          console.log("Tamanho arquivoOk: "+this.arquivoOk.length);
        }
        this.msgErro = "";
        this.msgOk = "";
      }
      //let file: File = fileList[0];

      // if (file.size <= 10485760 || this.tipoDocumento == 335) {
      // console.log(this.tipoDocumento);
      // console.log(JSON.stringify(this.tipoDocumento.idTipoDocumento));


    });
  }

  private validarInclusaoArquivosModuloContabilidade(arquivoEnviado: File) {

    if ( this.listaArquivosPCA.length === 0 ) {
      return false;
    }

    const {formatosPecasProcessuaisObrigatorios, codModulo} = this.getFormatosArquivosObrigatorioEModulo();

    const CONTABILIDADE = 4;

    if (!codModulo || codModulo != CONTABILIDADE) {
        return false;
    }

    const fomatoArquivoEnviado = this.getFormatoNomeArquivo(arquivoEnviado ? arquivoEnviado.name : '');
    const formatosPecasProcessuais = formatosPecasProcessuaisObrigatorios.split(";")

    const formatosObrigatorioXml = formatosPecasProcessuais.filter( formato => formato.trim() === 'XML');
  
    if (!formatosObrigatorioXml || formatosObrigatorioXml.length === 0) {
      return false;
    }

    const permitidos = formatosPecasProcessuais.filter( formatoPermitido => {
      const isFormato = formatoPermitido.trim() === fomatoArquivoEnviado;
      const isExisteAquivoNaListaDeDocumentosComOFormato =  this.isExisteAquivoNaListaDeDocumentosComOFormato(fomatoArquivoEnviado);
      return isFormato && isExisteAquivoNaListaDeDocumentosComOFormato;
    });

    if (permitidos && permitidos.length > 0) {
      this.showMensagemArquivoProibido(formatosPecasProcessuais, formatosPecasProcessuais.length) ;
      return true;
    }

    return false;
  }

  private showMensagemArquivoProibido(formatosPermitidos: any, quantidadePermitida: any) {
    const titulo = 'Atenção';

    const detalhesArquivos = formatosPermitidos.map( formato => "um arquivo do tipo " + formato).join(', ');
''
    const mensagem = `Só é permitida a inclusão de no máximo ${quantidadePermitida} arquivos. 
    Sendo: ${detalhesArquivos}.`;

    this.alertService.mostraAlerta(titulo, mensagem);

  }

  private getFormatoNomeArquivo(nome: string) {
    return nome.substr(nome.length - 3, nome.length).toUpperCase();
  }

  private getFormatosArquivosObrigatorioEModulo() {

    let idLocal = undefined;

    if ( typeof(this.tipoDocumento) === 'number') {
      idLocal = this.tipoDocumento;
    } else {
      idLocal = this.tipoDocumento.idTipoDocumento
    }

    if (!this.listaPecasProcessuaisObrigatoria || this.listaPecasProcessuaisObrigatoria.length === 0) {
      return {formatosPecasProcessuaisObrigatorios: undefined, codModulo: undefined};
    }

    const resultado = this.listaPecasProcessuaisObrigatoria
            .filter(peca => peca.idTipoDocumento === idLocal)
            .map(peca => {
              return {
                formatosPecasProcessuaisObrigatorios: peca.moduloPecaSap.tipoArquivos, 
                codModulo: peca.moduloPecaSap.modulo.codModulo
              };
            })[0];
    if (resultado) {
      return resultado;
    } else {
      return {formatosPecasProcessuaisObrigatorios: undefined, codModulo: undefined};
    }
  }

  private isExisteAquivoNaListaDeDocumentosComOFormato(fomatoArquivoEnviado: string): boolean {
    const existeNaLista = this.listaArquivosPCA.filter( arquivo => fomatoArquivoEnviado === this.getFormatoNomeArquivo(arquivo.nmArquivo));
    return existeNaLista.length > 0;
  }

  deletarArquivo(idArquivo, nomeArquivo) {
    this.alertService.mostraModalConfirmacao("Excluir Arquivo", "Você tem certeza que deseja excluir o arquivo " + nomeArquivo + "?",
      retornoModal => {
        if (retornoModal) {
          this.fileService.deletarArquivo(idArquivo).subscribe(data => {
            this.alertService.mostraAlerta("", "Arquivo excluído com sucesso.");
            this.carregarModal();
            //this.listarArquivosPCA();
          }, error => {
            this.alertService.mostraAlerta("", "Houve um erro ao excluir arquivo.");
          });
        }
      }
    );
  }

  /*assinarArquivos(arquivo) {

    // Assinar arquivo
    let assinar = this.AGORA.assinarArquivos(arquivo.idArquivoVinculado, this.PCAAtiva.id, this.usuarioLogado.dadosUsuario[0].cpf,this.usuarioService.obterDadosUsuario().perfil);
    assinar.subscribe(
      next => {
        console.log('Sucesso: %s', next);
        this.dismiss();
      },
      error => {
        console.log('Erro: %s', error);
        this.alertService.mostraAlerta("Erro encontrado", error);
      });

  }
*/

  exibirAssinantes(myEvent, assinantes) {

    let options: PopoverOptions = {
      cssClass: "popover-assinantes",
      showBackdrop: false,
      enableBackdropDismiss: false
    };

    let popover = this.popoverCtrl.create(PopoverAssinantesPage, { assinantes: assinantes }, options);
    popover.present({
      ev: myEvent
    });
  }

  inicarOpcoesAssinatura() {

    const cpf = environment.production ? this.usuarioLogado.dadosUsuario[0].cpf : environment.cpfAssinateTeste;

    this.opcoes = {
      arquivos: [],
      cpfUsuarioLogado: cpf,
      urlBackEndCallBack: environment.urlBackEndCallBackAssinatura,
      dadosBackEndCallBack: [],
      idPca: this.PCAAtiva.id,
      tipoArquivo: 'TIPO_VINCULADO'
    };
  }

  marcarArquivoParaAssinar(evento: any, arquivo: any) {

      if (evento.checked) {
        this.incluirArquivoNasOpcoesAssinatura(arquivo.pathArquivo);
        this.incluirArquivoNosDadosDoCallBackAssinatura(arquivo);
      } else {
        this.removerArquivoDasOpcoesAssinatura(arquivo.pathArquivo);
        this.removerArquivoDosDadosDoCallBackAssinatura(arquivo);
      }
  }

  private incluirArquivoNasOpcoesAssinatura(caminho: string) {
    this.opcoes.arquivos.push(caminho);
  }
  private removerArquivoDasOpcoesAssinatura(caminho: string) {
    this.opcoes.arquivos = this.opcoes.arquivos.filter(c => {
      return caminho !== c;
    });
  }

  private incluirArquivoNosDadosDoCallBackAssinatura(arquivo: any) {
    this.opcoes.dadosBackEndCallBack.push({
      idPca: this.PCAAtiva.id,
      idDocumento: arquivo.idArquivoVinculado,
      cpfAssinante: this.formatarCpf(this.usuarioLogado.dadosUsuario[0].cpf),
      perfil: this.usuarioService.obterDadosUsuario().perfil
    });
  }
  private removerArquivoDosDadosDoCallBackAssinatura(arquivo: any) {
    this.opcoes.dadosBackEndCallBack = this.opcoes.dadosBackEndCallBack.filter(a => {
      return a.idDocumento !== arquivo.idArquivoVinculado;
    });
  }

  private formatarCpf(valor) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
  }

  sucesso(evento: any) {
    this.carregarModal();
    this.inicarOpcoesAssinatura();
    // console.log(evento);
    // console.log('Assinatura realizada com sucesso.');
  }

  isAbilitarBotaoAssinatura() {
    return this.opcoes.arquivos.length > 0;
  }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-arquivos/modal-arquivos.ts